module.exports = __webpack_public_path__ + "media/assets/images/category/Thanksgiving@2x-887507789c7ea1a3d3cfc651d64bd36e.png";